import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "favorite-icon-wrapper" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "flag-container" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "lottery-name" }
const _hoisted_7 = { class: "countdown" }
const _hoisted_8 = { class: "time-block" }
const _hoisted_9 = { class: "time" }
const _hoisted_10 = { class: "label" }
const _hoisted_11 = { class: "time-block" }
const _hoisted_12 = { class: "time" }
const _hoisted_13 = { class: "label" }
const _hoisted_14 = { class: "time-block" }
const _hoisted_15 = { class: "time" }
const _hoisted_16 = { class: "label" }
const _hoisted_17 = { class: "country-name" }
const _hoisted_18 = { class: "favorite-icon-wrapper" }
const _hoisted_19 = ["src", "alt"]
const _hoisted_20 = ["src", "alt"]
const _hoisted_21 = { class: "draw-info" }
const _hoisted_22 = { class: "countdown" }
const _hoisted_23 = { class: "time-block" }
const _hoisted_24 = { class: "time" }
const _hoisted_25 = { class: "label" }
const _hoisted_26 = { class: "time-block" }
const _hoisted_27 = { class: "time" }
const _hoisted_28 = { class: "label" }
const _hoisted_29 = { class: "time-block" }
const _hoisted_30 = { class: "time" }
const _hoisted_31 = { class: "label" }
const _hoisted_32 = {
  key: 1,
  class: "bet-button",
  disabled: ""
}

import { computed, ref, onMounted, onUnmounted, watch } from 'vue'
import { useRouter } from 'vue-router'
import { getGameLogoUrl } from '@/utils/resultParser';
import { useTheme } from '@/composables/useTheme';
import type { UpcomingDraw } from '@/types/lottery';


const __default__ = {
  name: 'LotteryCard'
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  ...{
  name: 'LotteryCard'
},
  props: {
    lottery: {},
    layout: {},
    isFavorited: { type: Function }
  },
  emits: ["bet", "favorite", "remove"],
  setup(__props: any, { emit: __emit }) {

const { getAssetPath } = useTheme();
const favoriteIcon = getAssetPath('icons', 'favorite') || '/img/icons/favorite.svg';
const favoriteFilledIcon = getAssetPath('icons', 'favorite-filled') || '/img/icons/favorite-filled.svg';
const router = useRouter()



const props = __props;

const emit = __emit;

const isFavoritedProp = computed(() => {
  return typeof props.isFavorited === 'function' ? props.isFavorited(props.lottery) : false;
});
const countdown = ref({
  hours: 0,
  minutes: 0,
  seconds: 0
});

const updateCountdown = () => {
  if (!props.lottery?.cutoff) {
    countdown.value = { hours: 0, minutes: 0, seconds: 0 };
    return;
  }
  const now = new Date();
  const cutoffRaw = props.lottery.cutoff as string | Date;
  const cutoffTime = typeof cutoffRaw === 'string'
    ? new Date(cutoffRaw.replace(' ', 'T'))
    : new Date(cutoffRaw);
  const diff = cutoffTime.getTime() - now.getTime();

  if (diff <= 0) {
    countdown.value = { hours: 0, minutes: 0, seconds: 0 };
    return;
  }

  countdown.value = {
    hours: Math.floor(diff / (1000 * 60 * 60)),
    minutes: Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)),
    seconds: Math.floor((diff % (1000 * 60)) / 1000)
  };
};

let timer: number;

// --- MOBILE DETECTION LOGIC ---
const isMobile = ref(window.matchMedia('(max-width: 768px)').matches);
let mediaQueryList: MediaQueryList;
const handleResize = () => {
  isMobile.value = window.matchMedia('(max-width: 768px)').matches;
};
// --- END MOBILE DETECTION LOGIC ---

onMounted(() => {
  updateCountdown();
  timer = window.setInterval(updateCountdown, 1000);

  mediaQueryList = window.matchMedia('(max-width: 768px)');
  mediaQueryList.addEventListener('change', handleResize);
  handleResize();
});
onUnmounted(() => {
  if (timer) {
    clearInterval(timer);
  }
  if (mediaQueryList && handleResize) {
    mediaQueryList.removeEventListener('change', handleResize);
  }
});

const toggleFavorite = (event: MouseEvent) => {
  event.stopPropagation();
  emit('favorite');
};

const navigateToDetail = () => {
  if (props.lottery && props.lottery.game_slug) {
    router.push(`/lottery/${props.lottery.game_slug}`);
  }
};

const handleCardClick = (event: MouseEvent) => {
  // Only navigate if the click is on the card background (not on interactive children)
  // This is now a fallback for keyboard accessibility (e.g. Enter/Space on the card)
  if (event.target === event.currentTarget) {
    navigateToDetail();
  }
};

const handleBet = () => {
  emit('bet');
};

const formattedDrawTime = computed(() => {
  if (!props.lottery?.cutoff) return '';
  const cutoffRaw = props.lottery.cutoff as string | Date;
  const date = typeof cutoffRaw === 'string'
    ? new Date(cutoffRaw.replace(' ', 'T'))
    : new Date(cutoffRaw);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  return `${day}/${month}/${year}, ${hours}:${minutes}`;
});

onMounted(() => {
  mediaQueryList = window.matchMedia('(max-width: 768px)');
  mediaQueryList.addEventListener('change', handleResize);
  handleResize();
});
onUnmounted(() => {
  mediaQueryList.removeEventListener('change', handleResize);
});

const betClosed = ref(false);

watch(
  () => [countdown.value.hours, countdown.value.minutes, countdown.value.seconds],
  ([hours, minutes, seconds]) => {
    if (hours === 0 && minutes === 0 && seconds === 0 && !betClosed.value) {
      betClosed.value = true;
      setTimeout(() => {
        emit('remove');
      }, 3000);
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["draw-card", { horizontal: _ctx.layout === 'horizontal' }]),
    onClick: handleCardClick,
    tabindex: "0",
    role: "button"
  }, [
    _createElementVNode("div", {
      class: "card-content",
      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
    }, [
      (_ctx.layout === 'horizontal')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("button", {
              class: _normalizeClass(["favorite-btn horizontal-favorite", { active: isFavoritedProp.value }]),
              onClick: _withModifiers(toggleFavorite, ["stop"]),
              "aria-label": _ctx.$t('forms.toggleFavorite')
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("img", {
                  src: isFavoritedProp.value ? _unref(favoriteFilledIcon) : _unref(favoriteIcon),
                  alt: _ctx.$t('forms.favorite'),
                  class: _normalizeClass(["favorite-icon", { 'active-favorite-icon': isFavoritedProp.value }])
                }, null, 10, _hoisted_3)
              ])
            ], 10, _hoisted_1),
            _createElementVNode("div", {
              class: "left-section",
              onClick: navigateToDetail
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("img", {
                  src: _unref(getGameLogoUrl)(_ctx.lottery.game_logo),
                  alt: `${_ctx.lottery.country} ${_ctx.$t('forms.flag')}`,
                  class: "flag"
                }, null, 8, _hoisted_5)
              ]),
              _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.lottery.game_name), 1)
            ]),
            _createElementVNode("div", {
              class: "right-section",
              onClick: navigateToDetail
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(String(countdown.value.hours).padStart(2, '0')), 1),
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('time.hours')), 1)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, _toDisplayString(String(countdown.value.minutes).padStart(2, '0')), 1),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('time.mins')), 1)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, _toDisplayString(String(countdown.value.seconds).padStart(2, '0')), 1),
                  _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('time.secs')), 1)
                ])
              ])
            ])
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", {
              class: "card-header",
              onClick: navigateToDetail
            }, [
              _createElementVNode("h3", _hoisted_17, _toDisplayString(_ctx.lottery.game_name), 1),
              _createElementVNode("button", {
                class: _normalizeClass(["favorite-btn", { active: isFavoritedProp.value }]),
                onClick: _withModifiers(toggleFavorite, ["stop"])
              }, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("img", {
                    src: isFavoritedProp.value ? _unref(favoriteFilledIcon) : _unref(favoriteIcon),
                    alt: _ctx.$t('forms.favorite'),
                    class: "favorite-icon"
                  }, null, 8, _hoisted_19)
                ])
              ], 2)
            ]),
            _createElementVNode("div", {
              class: "flag-container",
              onClick: navigateToDetail
            }, [
              _createElementVNode("img", {
                src: _unref(getGameLogoUrl)(_ctx.lottery.game_logo),
                alt: `${_ctx.lottery.country} ${_ctx.$t('forms.flag')}`,
                class: "flag"
              }, null, 8, _hoisted_20)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, _toDisplayString(String(countdown.value.hours).padStart(2, '0')), 1),
                  _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('time.hours')), 1)
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, _toDisplayString(String(countdown.value.minutes).padStart(2, '0')), 1),
                  _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t('time.mins')), 1)
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, _toDisplayString(String(countdown.value.seconds).padStart(2, '0')), 1),
                  _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('time.secs')), 1)
                ])
              ])
            ])
          ], 64))
    ]),
    (!betClosed.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "bet-button",
          onClick: _withModifiers(handleBet, ["stop"])
        }, _toDisplayString(_ctx.$t('common.betNow')), 1))
      : (_openBlock(), _createElementBlock("button", _hoisted_32, _toDisplayString(_ctx.$t('common.betClosed')), 1))
  ], 2))
}
}

})